var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex titan-list-content",class:_vm.className},[_vm._t("list-icon"),_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }